import React from "react";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
const businessHours = [{
  day: "Email",
  hours: "hello@blinklabmedia.com"
}, {
  day: "Phone",
  hours: "803-470-4042"
}, {
  day: "Address",
  hours: "1121 Broad Street Suite 1 #1008 Sumter SC 29150"
}];
export default function Closingcontactstrip() {
  return <section data-section-id="260036" id="closingcontactstrip" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {/* Left Side: Privacy Questions */}
          <div className="flex flex-col gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 text-secondary">
                PRIVACY QUESTIONS?
              </h2>
              <p className="text-muted-foreground text-lg font-default">
                We are committed to your data security. Please reach out to us directly if you have any questions or concerns regarding our privacy practices or how we handle your information.
              </p>
            </div>
            
            <div className="flex flex-col gap-6">
              {/* Email Item */}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary shrink-0">
                  <Mail className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold font-default text-foreground mb-1">
                    Email Support
                  </h3>
                  <Link to="mailto:hello@blinklabmedia.com" className="text-muted-foreground hover:text-secondary transition-colors block font-default">
                    hello@blinklabmedia.com
                  </Link>
                </div>
              </div>
              
              <Separator className="bg-border/60" />
              
              {/* Phone Item */}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary shrink-0">
                  <Phone className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold font-default text-foreground mb-1">
                    Direct Line
                  </h3>
                  <Link to="tel:8034704042" className="text-muted-foreground hover:text-secondary transition-colors block font-default">
                    803-470-4042
                  </Link>
                </div>
              </div>
              
              <Separator className="bg-border/60" />
              
              {/* Address Item */}
              <div className="flex items-start gap-4">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary shrink-0">
                  <MapPin className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold font-default text-foreground mb-1">
                    Mailing Address
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    1121 Broad Street Suite 1 #1008<br />
                    Sumter, SC 29150
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Contact Card */}
          <Card className="shadow-lg border-border/50 h-full bg-card">
            <CardHeader className="bg-muted/30 border-b border-border/50 pb-6 rounded-t-lg">
              <div className="flex items-center gap-3 mb-2">
                <Clock className="w-6 h-6 text-secondary" />
                <CardTitle className="text-2xl font-default text-foreground">Contact Details</CardTitle>
              </div>
              <CardDescription className="text-base font-default">
                Quick access to our primary communication channels and physical location.
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-6 flex flex-col gap-8">
              <Table>
                <TableBody>
                  {businessHours.map((item, i) => <TableRow key={i} data-index={i} className="border-b border-border/50 last:border-0 hover:bg-transparent">
                      <TableCell className="font-medium text-foreground py-4 text-base font-default">
                        {item.day}
                      </TableCell>
                      <TableCell className="text-right text-muted-foreground py-4 text-base font-default">
                        {item.hours}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>

              <div className="flex flex-col gap-4 mt-4">
                <Link to="/ContactPage" className="inline-flex items-center justify-center px-6 py-3 border-2 border-secondary text-secondary font-semibold rounded-lg hover:bg-secondary hover:text-white transition-all text-center font-default">
                  Contact Us
                </Link>
                <Link to="/TermsOfServicePage" className="text-sm text-muted-foreground hover:text-secondary underline underline-offset-4 text-center transition-colors font-default">
                  View our Terms of Service
                </Link>
              </div>
            </CardContent>
          </Card>
          
        </div>
      </div>
    </section>;
}